export default __webpack_public_path__ + "static/media/Q06_輕盈水感、果汁般清爽質地.69a85aca.mp4";